import { render } from "./AppointmentActionModal.vue?vue&type=template&id=8afac472&scoped=true"
import script from "./AppointmentActionModal.vue?vue&type=script&lang=js"
export * from "./AppointmentActionModal.vue?vue&type=script&lang=js"

import "./AppointmentActionModal.vue?vue&type=style&index=0&id=8afac472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8afac472"]])

export default __exports__